var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upsell-card',{attrs:{"offer":_vm.offer,"currency":_vm.currency,"index":_vm.index,"count":_vm.count,"options":_vm.options,"title":_vm.title,"lead":_vm.lead,"agree":_vm.agree},on:{"apply":function($event){return _vm.$emit('apply')}}})}
var staticRenderFns = []

export { render, staticRenderFns }